<div class="main-page-wrapper p0 overflow-hidden">
    <div class="error-page d-lg-flex align-items-center justify-content-center">
      <!-- <div class="img-holder order-lg-last">
        <img src="assets/images/media/404.svg" alt="" class="w-100 illustration">
        <img src="assets/images/media/404-q.svg" alt="" class="shapes qus">
      </div> -->
      <div class="text-center">
        <!-- <div class="logo"><a [routerLink]="['/']"><img src="assets/images/logo/deski_05.svg" alt=""></a></div> -->
        <div class="icon-box mb-25"><img alt="" src="assets/images/icon/faild.png"></div>
        <h1 class="font-slab mb-25">Payment Faild!</h1>

        <div class="d-lg-flex align-items-center justify-content-center"><button [routerLink]="['/']" class="theme-btn-one btn-lg">Back to homepage</button></div>
      </div> <!-- /.text-wrapper -->
    </div>
  </div>
  